import React from 'react'
import ReactDOM from 'react-dom'
import './styles/common.scss'
import App from './pages/home/index'

ReactDOM.render(<App />, document.getElementById('app'))
